import { useState } from 'react';
import { Slider } from '../../components/Slider';
import { HelpTooltip } from '../../components/HelpTooltip';
import { useEditorStore } from '../../store/editorStore';
import { HSL_COLORS, type HslColor } from '../editState';

const SWATCH: Record<HslColor, string> = {
  red: '#e0524f',
  orange: '#e08a3c',
  yellow: '#d8c948',
  green: '#5ab75a',
  aqua: '#4fbfb0',
  blue: '#4f7fe0',
  purple: '#8a5ad8',
  magenta: '#d85ab0',
};

export function ColorPanel() {
  const state = useEditorStore((s) => s.state);
  const set = useEditorStore((s) => s.set);
  const update = useEditorStore((s) => s.update);
  const [band, setBand] = useState<HslColor>('red');

  const b = state.hsl[band];

  return (
    <>
      <Slider
        label="Vibrance"
        help="vibrance"
        value={state.vibrance}
        min={-100}
        max={100}
        onChange={(v) => set('vibrance', v)}
      />
      <Slider
        label="Saturation"
        help="saturation"
        value={state.saturation}
        min={-100}
        max={100}
        onChange={(v) => set('saturation', v)}
      />

      <p className="hint">
        HSL / Color Mixer <HelpTooltip id="hsl" />
      </p>
      <div className="swatches">
        {HSL_COLORS.map((c) => (
          <button
            key={c}
            className={`swatch ${band === c ? 'is-active' : ''}`}
            style={{ background: SWATCH[c] }}
            title={c}
            aria-label={c}
            onClick={() => setBand(c)}
          />
        ))}
      </div>
      <Slider
        label="Hue"
        value={b.hue}
        min={-100}
        max={100}
        onChange={(v) => update((d) => (d.hsl[band].hue = v))}
      />
      <Slider
        label="Saturation"
        value={b.sat}
        min={-100}
        max={100}
        onChange={(v) => update((d) => (d.hsl[band].sat = v))}
      />
      <Slider
        label="Luminance"
        value={b.lum}
        min={-100}
        max={100}
        onChange={(v) => update((d) => (d.hsl[band].lum = v))}
      />
    </>
  );
}
